import { createSlider } from "./common";

export function createTestimonialSlider() {
  $(".testimonial-slider-block").each(function () {
    const block = $(this);
    const wrapper = block.find(".testimonial-slider");

    if (!wrapper.length) {
      return;
    }

    const prevArrow = block.find(".nav-icon.prev");
    const nextArrow = block.find(".nav-icon.next");
    const appendDots = block.find(".slider-nav");
    const options = {
      slideTransition: "linear",
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      dots: true,
      swipeToSlide: true,
      customPaging: () =>
        $('<button type="button"><span class="dot black" /></button>'),
    };

    if (appendDots.length) {
      options.appendDots = appendDots;
    }

    const slider = createSlider({ wrapper, prevArrow, nextArrow, options });

    if (slider) {
      slider.on("afterChange", (event, slick) => {
        const dots = slick.$dots;

        if (!dots || !dots.find(document.activeElement).length) {
          return;
        }

        setTimeout(() => {
          dots.find(".slick-active button").first().focus();
        }, 0);
      });
    }
  });
}



// WEBPACK FOOTER //
// ./scripts/func/testimonialSlider.js